<template>
  <div class="prenotazioni-setting">
    <div class="header">
      <h1>{{ $t('prenotazioniSetting') }}</h1>
       <a href="#" class="btn btn-outline-success btn-sm" @click="home">Home</a>
    </div>
    
    <div class="table-container">
      <table class="neumorphic-table">
        <thead>
          <tr>
            <th>{{ $t('nomeSala') }}</th>
            <th>{{ $t('maxCoperti') }}</th>
            <th>{{ $t('maxCopertiTavolo') }}</th>
            <th>Pranzo Start</th>
            <th>Pranzo End</th>
            <th>Cena Start</th>
            <th>Cena End</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="setting in settings" :key="setting.codicesala">
            <td>{{ setting.nomeSala }}</td>
            <td>
              <input 
                type="number" 
                v-model.number="setting.maxCoperti" 
                @blur="updateSetting(setting)"
                class="neumorphic-input"
              >
            </td>
            <td>
              <input 
                type="number" 
                v-model.number="setting.maxCopertiTavolo" 
                @blur="updateSetting(setting)"
                class="neumorphic-input"
              >
            </td>
            <td>
              <input 
                type="time" 
                v-model="setting.pranzoStart" 
                @blur="updateSetting(setting)"
                class="neumorphic-input time-input"
              >
            </td>
            <td>
              <input 
                type="time" 
                v-model="setting.pranzoEnd" 
                @blur="updateSetting(setting)"
                class="neumorphic-input time-input"
              >
            </td>
            <td>
              <input 
                type="time" 
                v-model="setting.cenaStart" 
                @blur="updateSetting(setting)"
                class="neumorphic-input time-input"
              >
            </td>
            <td>
              <input 
                type="time" 
                v-model="setting.cenaEnd" 
                @blur="updateSetting(setting)"
                class="neumorphic-input time-input"
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { store } from '../store/store.js'

export default {
  name: 'PrenotazioniSetting',
  data() {
    return {
      settings: [],
      store
    }
  },
  methods: {
    fetchSettings() {
      this.axios.get(this.store.path + 'prenotazioni-setting', {
        headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
      }).then(response => {
        // dalla risposta prendo solo i setting che non sono asporto
        this.settings = response.data.filter(setting => 
          setting.codicesala && setting.codicesala.toLowerCase() !== 'asporto'
        )
      }).catch(error => {
        console.error("Error fetching settings:", error)
      })
    },
    updateSetting(setting) {
      this.axios.post(this.store.path + 'prenotazioni-setting', setting, {
        headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
      }).then(() => {
        // Success feedback if needed
      }).catch(error => {
        console.error("Error updating setting:", error)
      })
    },
    home() {
      this.$router.push({ name: 'Gestionale' })
    }
  },
  mounted() {
    this.fetchSettings()
  }
}
</script>

<style scoped>
.prenotazioni-setting {
  padding: 40px;
  min-height: 90vh;
  background: #f0f0f0;
}

.header h1 {
  color: #333;
  margin-bottom: 30px;
  text-align: center;
}

.table-container {
  display: flex;
  justify-content: center;
}

.neumorphic-table {
  width: 100%;
  max-width: 800px;
  border-collapse: separate;
  border-spacing: 0 15px;
}

.neumorphic-table th {
  padding: 15px;
  color: #666;
  text-align: left;
}

.neumorphic-table td {
  padding: 15px;
  background: #e0e0e0;
  box-shadow: inset -5px 5px 10px #bebebe, inset 5px -5px 10px #ffffff;
}

.neumorphic-table tr td:first-child {
  border-radius: 15px 0 0 15px;
  font-weight: bold;
}

.neumorphic-table tr td:last-child {
  border-radius: 0 15px 15px 0;
}

.neumorphic-input {
  width: 80px;
  border: none;
  background: #f0f0f0;
  box-shadow: inset -2px 2px 5px #bebebe, inset 2px -2px 5px #ffffff;
  padding: 8px;
  border-radius: 8px;
  outline: none;
  text-align: center;
}

.neumorphic-input:focus {
  box-shadow: inset -3px 3px 7px #bebebe, inset 3px -3px 7px #ffffff;
}

.time-input {
  width: 110px;
}
</style>
